export const CASUAL_DATING = 8;
export const WEIGHT_LOSS = 19;
export const LANGUAGE = 15;
export const MEAL_DELIVERY = 10;
export const GAMING = 20;
